// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { createFileRoute } from "@tanstack/react-router";
import { RequirePermission } from "@/components/shared/require-permission";
import { StoreSettingsCompare } from "@/features/stores/store-settings-compare";
import { PAGE_PERMISSIONS } from "@/lib/auth/page-permissions";

export const Route = createFileRoute("/_authenticated/stores/compare/$storeNameA/$storeNameB")({
  component: StoreCompare,
});

function StoreCompare() {
  const { storeNameA, storeNameB } = Route.useParams();
  return (
    <RequirePermission permission={PAGE_PERMISSIONS.stores}>
      <StoreSettingsCompare storeNameA={storeNameA} storeNameB={storeNameB} />
    </RequirePermission>
  );
}
